module.exports = __webpack_public_path__ + "static/media/Moldflow Synergy.ac5d5863.png";